import { AxiosError, AxiosResponse } from 'axios';
import { TFunction } from '@packlink/translation-provider';
import { API_ERRORS_MAPPING, API_ERRORS_MAPPING_KEYS } from '@constants/apiErrors';
import { IError, IErrorData } from '@types';
import { camelToSnakeUpperCase } from './camelToSnakeUpperCase';

export type PaymentApiError = {
    message?: string;
    error_code?: string;
    error_field?: {
        name?: string;
        value?: string;
    };
};

export type PaymentError = {
    key: string;
    value?: string;
};

/* istanbul ignore next: it's going to the SDK */
// TODO: Move to SDK
export const formatError = (error: AxiosError): IError => {
    const response: AxiosResponse | undefined = error.response;
    const data: IErrorData = response && response.data;
    const message: string = data
        ? data.message
            ? data.message
            : data.messages && data.messages.length
              ? (data.messages[0].message as string)
              : ''
        : '';
    const status: number | null = response ? response.status : null;
    return status ? { status, message } : { message };
};

export const getPaymentErrors = (errors?: PaymentApiError[]): PaymentError[] => {
    if (!errors || !errors.length) return [{ key: API_ERRORS_MAPPING_KEYS.DEFAULT }];

    return errors.map((error: PaymentApiError) => {
        const errorCode = error.error_code ?? '';
        const errorMessage = error.message ?? '';
        const errorFieldValue = error.error_field?.value ?? '';

        if (errorCode === API_ERRORS_MAPPING.CARRIER_PRODUCT_FAILURE) {
            if (errorMessage.includes('Drop Off point id is not valid')) {
                return { key: 'payment.error.carrier-failure-drop-off' };
            } else if (errorMessage.includes('The dates of the user and the service do not match')) {
                return { key: 'payment.error.collection-date' };
            } else if (errorMessage.includes('Service not available for this user')) {
                return { key: 'payment.error.service-not-available' };
            } else {
                return { key: API_ERRORS_MAPPING_KEYS[camelToSnakeUpperCase(errorCode)] };
            }
        } else if (Object.values<string>(API_ERRORS_MAPPING).includes(errorCode)) {
            return {
                key: API_ERRORS_MAPPING_KEYS[camelToSnakeUpperCase(errorCode) as keyof typeof API_ERRORS_MAPPING_KEYS],
                ...(errorFieldValue && { value: errorFieldValue }),
            };
        } else {
            return { key: API_ERRORS_MAPPING_KEYS.DEFAULT };
        }
    });
};

export const getPaymentErrorsTranslated = (t: TFunction, errors: PaymentError[]): string => {
    const errorsTranslated = errors.map((error) => {
        const errorValueTranslated =
            (error.value && t('payment.error.please-check-data', { value: error.value })) ?? '';
        return `${t(error.key)}${errorValueTranslated}`;
    });
    return Array.from(new Set(errorsTranslated)).join('<br>');
};
